@if (tutorialToPlay && tutorialToPlay?._id) {
  <div class="dialog-wrapper">
    <div class="feature-info">
      <div class="tutorial-outer-wrapper">
        @if (tutorialToPlay) {
          <div class="tutorial-display-wrapper">
            <header>
              <div class="default-flex space-between align-center">
                <div class="tutorial-header-label">{{ tutorialToPlay?.name }}</div>
                <div class="close-btn">
                  <button mat-stroked-button mat-dialog-close (click)="close()">Close</button>
                </div>
              </div>
            </header>
            <main>
              @if (tutorialToPlay?.htmlText) {
                <div class="html-contents-wrapper">
                  <div class="html-contents" [innerHTML]="tutorialToPlay.htmlText | safe: 'html'"></div>
                </div>
              }
              <div class="tutorial-content-switch">
                @switch (tutorialToPlay?.sourceType) {
                  @case ('video') {
                    <div class="video-case">
                      @if (videoDetails) {
                        <yeehro-single-media-player [videoDetails]="videoDetails" [stealthMode]="true"></yeehro-single-media-player>
                      }
                    </div>
                  }
                  @case ('image') {
                    <div class="video-case">
                      <img [src]="tutorialToPlay?.sourcePath">
                    </div>
                  }
                  @default {
                    <div class="default-case">
                      <!-- <p>Default Case. Just show htmlText with innerHTML. It's being shown below</p> -->
                    </div>
                  }
                }
              </div>
            </main>
          </div>
        }
      </div>
    </div>
    <div class="dialog-footer">
      <mat-dialog-actions class="two-button-full-width-flex">
        <button mat-stroked-button mat-dialog-close (click)="close()">Close</button>
      </mat-dialog-actions>
    </div>
  </div>
}